import {Component, inject, Input} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ModalComponent} from "../modal.component";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {ModalService} from "src/app/shared/data-access/modal.service";
import {MatInputModule} from "@angular/material/input";
import {SolutionService} from "src/app/features/knowledge-database/data-access/solution.service";

@Component({
  selector: "app-edit-media-item-modal",
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  template: `
    <app-modal modalId="editMediaItemModal" (closeModal)="closeModal()">
      <ng-container>
        <h1>Datei umbenennen</h1>

        <form [formGroup]="mediaItemForm" class="item-form">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Bezeichnung</mat-label>
            <input matInput type="text" formControlName="filename"/>
          </mat-form-field>
        </form>

        <button class="btn btn-qundis-primary mt-4" (click)="onSubmit()">
          Speichern
        </button>
      </ng-container>
    </app-modal>
  `,
  styles: [
    `
      .item-form {
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class EditMediaItemModalComponent {
  formBuilder = inject(FormBuilder);
  modalService = inject(ModalService);
  solutionService = inject(SolutionService);

  mediaItemForm: FormGroup = this.formBuilder.group({
    filename: ["", Validators.required],
  });

  ngOnInit() {
    this.mediaItemForm.patchValue({
      filename: this.solutionService.mediaFileBeingEdited()?.name,
    });
  }

  openModal() {
    this.modalService.openModal("editMediaItemModal");
  }

  closeModal() {
    this.solutionService.mediaItemBeingEdited$.next(null);
    this.modalService.closeModal("editMediaItemModal");
  }

  onSubmit() {
    this.solutionService.updateMediaItem$.next(
      this.mediaItemForm.get("filename")?.value
    );
    this.closeModal();
  }
}
